<template>
  <v-container id="facturas-generadas" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-text-box-multiple" inline class="px-5 py-3" title="Facturas">
      <v-data-table
       :headers="headers"
       :items="facturas.data"
       :page-count="facturas.last_page"
       :page="facturas.page"
       :server-items-length="facturas.total"
       :sort-by="sortby"
       :sort-desc="sortdesc"
       @update:options="getData($event)"
      >
        <template #item="{ item }">
          <tr>
            <td class="text-start">
              {{ item.fecha }}
            </td>
            <td>
              {{ item.tipo_factura.codigo }}
            </td>
            <td>
              {{ generarNumero(item) }}
            </td>
            <td>
              {{ item.contraparte }}
            </td>
            <td>
              {{ montoMoneda(item) }}
            </td>
            <td class="text-end">
              <v-tooltip content-class="top" top>
                <template v-if="item.documentacion_id" v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openFile(item.documentacion_id)"
                  >
                    mdi-download-box
                  </v-icon>
                </template>
                <span>Ver Documentación</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    name: 'FacturasGeneradas',
    props: {},
    data () {
      return {
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fecha_factura' },
          { text: 'Tipo', value: 'tipo_factura.codigo' },
          { text: 'Número', sortable: true, value: 'numero' },
          { text: 'Contraparte', sortable: true, value: 'contraparte' },
          { text: 'Monto', sortable: true, value: 'monto' },
          { text: 'Acciones', align: 'end', value: 'documentacion_id' },
        ],
        facturas: [],
        op: {},
        sortby: ['fecha'],
        sortdesc: [true],
        options: {
          itemsPerPage: 10,
        },
      }
    },
    computed: {},
    created () {
      this.getFacturas()
    },
    methods: {

      getData (data) {
        this.op = data
        this.getFacturas(data.page, data.itemsPerPage, data.sortBy, data.sortDesc)
      },

      getFacturas: async function (page = 1, itemsPerPageOptions = this.options.itemsPerPage, sortBy = this.sortby, sortDesc = this.sortDesc) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/facturas_generadas' + '?page=' + page + '&itemsPerPage=' + itemsPerPageOptions + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc,
        }).then(response => {
          this.facturas = response
        })
      },

      generarNumero (item) {
        return (('00000000' + item.id).slice(-8))
      },

      montoMoneda (item) {
        return (item.moneda.simbolo + ' ' + item.monto)
      },

      openFile (internalid) {
        this.downloadDocument(internalid, false)
      },

      downloadDocument (internalid, isPublic) {
        this.$http.get('/api/files/download/' + internalid + '/disk/' + isPublic, { responseType: 'arraybuffer' })
          .then(response => {
            this.downloadFile(response, 'documentacion')
          }, response => {
          },
          )
      },

      downloadFile (response, filename) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' })
        var url = URL.createObjectURL(newBlob)
        var a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()
      },
    },
  }
</script>
